export const LAYOUT_TYPE_INITIALIZATION = 'initialization';
export const LAYOUT_TYPE_ADDED = 'added';
export const LAYOUT_TYPE_REMOVED = 'removed';
export const LAYOUT_TYPE_IMPERATIVE = 'imperative';
export const LAYOUT_TYPE_OBJECT_MODIFIED = 'object_modified';
export const LAYOUT_TYPE_OBJECT_MODIFYING = 'object_modifying';
